import _ from 'lodash'

export const IRegistrableInstance = class IRegistrableInstance {
  registered () { throw new Error('Function registered() must be overridden in ' + this.constructor.name + ' class!') }
  unregistered () { throw new Error('Function unregistered() must be overridden in ' + this.constructor.name + ' class!') }
}

class Registrable {
  constructor () {
    this.instances = []
  }

  register (el, instance) {
    if (!(instance instanceof IRegistrableInstance)) {
      throw new Error('ERROR')
    }

    if (Comparer.instanceExists(this.instances, el)) return
    this._addInstance(instance)
  }

  unregister (el) {
    this._removeInstance(Comparer.findInstance(this.instances, el))
  }

  _removeInstance (instance) {
    if (!instance) return

    this.instances = _.filter(this.instances, i => i !== instance)
    instance.unregistered()
  }

  _addInstance (instance) {
    if (!instance) return

    this.instances = _.union(this.instances, [instance])
    instance.registered()
  }
}

class Comparer {
  static instanceExists (instance, el) {
    return !!this.findInstance(instance, el)
  }

  static findInstance (instances, el) {
    return _.find(instances, ['el', el])
  }
}

export default Registrable
